import React from 'react';
import T from 'prop-types';
import Highcharts from 'highcharts';
import HighchartsHeatMap from 'highcharts/modules/heatmap';
import exportData from 'highcharts/modules/export-data';
import exporting from 'highcharts/modules/exporting';
import accessibility from 'highcharts/modules/accessibility';
import HighchartsReact from 'highcharts-react-official';

exportData(Highcharts);
exporting(Highcharts);
accessibility(Highcharts);
HighchartsHeatMap(Highcharts);


const HeatMapChart = ({ config }) => {
  return (
    <div className="heatmap__chart">
      <HighchartsReact highcharts={Highcharts} options={config} />
    </div>
  );
};

HeatMapChart.propTypes = {
  config: T.object,
};

export default HeatMapChart;
